@use '../../scss/utility';
@use './gallery-vars';

:host {
  @include gallery-vars.wb-gallery-vars;

  @include utility.breakpoint-from('mq3') {
    @include gallery-vars.wb-gallery-desktop-vars;
  }

  display: block;
  position: relative;
}

.inner {
  position: relative;
}

.controls {
  inset-block-start: 0;
  inset-inline: 0;
  aspect-ratio: var(--gallery-ratio);
  position: absolute;
}

.main,
.thumbs {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  flex-shrink: 0;
  flex-grow: 0;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  scrollbar-width: none; // firefox

  &::-webkit-scrollbar {
    display: none; // safari + chrome
  }
}

.thumbs {
  margin-block-start: var(--gallery-gap);
  gap: var(--gallery-thumbnails-gap);
  scroll-padding-inline-start: var(--gallery-thumbnail-slider-scroll-padding-start);
}

.thumb {
  height: var(--gallery-thumbnail-height);
  width: var(--gallery-thumbnail-width);
  overflow: hidden;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
  scroll-snap-align: start;
  border-radius: var(--gallery-thumbnail-border-radius);

  &::before {
    position: absolute;
    content: '';
    z-index: 1;
    inset: 0;
    background: linear-gradient(180deg, #0000, #0000, #0008);
    border-radius: var(--gallery-thumbnail-border-radius);
  }

  &::after {
    position: absolute;
    content: '';
    z-index: 1;
    inset: 0;
    border: var(--gallery-thumbnail-border-weight) solid var(--gallery-thumbnail-border-color);
    border-radius: var(--gallery-thumbnail-border-radius);
  }

  &.is-active::after {
    @include gallery-vars.wb-gallery-thumb-selected-vars;
  }

  &:hover::before,
  &.is-active::before {
    background: linear-gradient(180deg, #fff0, #fff0, #fff8);
  }

  &:hover::after {
    @include gallery-vars.wb-gallery-thumb-hover-vars;
  }
}

.toggle-fullscreen-button {
  position: absolute;
  inset-block-end: utility.wb-pixel-to-rem(16px);
  inset-inline-end: utility.wb-pixel-to-rem(16px);
}

.exit-fullscreen-button {
  position: absolute;
  inset-block-start: utility.wb-pixel-to-rem(16px);
  inset-inline-end: utility.wb-pixel-to-rem(16px);
}

.arrow {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);

  &.is-previous {
    inset-inline-start: utility.wb-pixel-to-rem(16px);
  }

  &.is-next {
    inset-inline-end: utility.wb-pixel-to-rem(16px);
  }
}

::slotted(.wb-gallery-item) {
  scroll-snap-align: start;
}

:host([fullscreen]) {
  @include gallery-vars.wb-gallery-fullscreen-vars;

  position: fixed;
  inset: 0;
  background: var(--gallery-overlay-background-color);
  z-index: utility.$wb-z-index-gallery-fullscreen-mode;
  display: block;

  .inner {
    width: 86%;
    margin-block: 50vh 0;
    margin-inline: auto;
    max-width: utility.wb-pixel-to-rem(1680px);
    transform: translateY(-50%);
  }
}

:host(.is-small) {
  .toggle-fullscreen-button {
    inset-block-end: utility.wb-pixel-to-rem(8px);
    inset-inline-end: utility.wb-pixel-to-rem(8px);
  }
}

@include utility.breakpoint-to('mq2') {
  .exit-fullscreen-button {
    inset-block-start: utility.wb-pixel-to-rem(8px);
    inset-inline-end: utility.wb-pixel-to-rem(8px);
  }
}
